"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const prop_types_1 = __importDefault(require("prop-types"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const oxygen_utils_1 = require("@8x8/oxygen-utils");
const themeName_1 = require("../constants/themeName");
const Containers_1 = require("./Containers");
const types_1 = require("../types");
const getDefaultSize = (size, isClassic) => {
    // To be removed in V2
    let finalDefaultSize = size;
    if (isClassic) {
        finalDefaultSize = size === types_1.buttonSize.medium ? types_1.buttonSize.big : size;
    }
    else {
        finalDefaultSize = size === types_1.buttonSize.big ? types_1.buttonSize.medium : size;
    }
    return finalDefaultSize;
};
const Button = ({ isDisabled, forwardedRef, secondary, variant, theme, size, testId, onClick, onKeyDown, isDestructive, ...rest }) => {
    const [isHovered, setIsHovered] = react_1.default.useState(false);
    const handleMouseEnter = () => {
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const ButtonComponent = rest.isCircular ? Containers_1.ButtonCircular : Containers_1.ButtonRegular;
    const handleOnClick = (ev) => {
        if (isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onClick) {
            onClick(ev);
        }
    };
    const handleOnKeyDown = (ev) => {
        if (((0, oxygen_utils_1.isSpaceEvent)(ev) || (0, oxygen_utils_1.isEnterEvent)(ev)) && isDisabled) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
        }
        if (onKeyDown) {
            onKeyDown(ev);
        }
    };
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(ButtonComponent, { "aria-disabled": isDisabled, isHovered: isHovered, onClick: handleOnClick, onKeyDown: handleOnKeyDown, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ref: forwardedRef, size: getDefaultSize(size, theme.isClassic), variant: secondary ? types_1.buttonVariant.secondary : variant, theme: theme, type: "button", isDestructive: isDestructive, ...(0, oxygen_config_1.getTestAttributes)(testId), ...rest })));
};
Button.propTypes = {
    children: prop_types_1.default.node.isRequired,
    variant: prop_types_1.default.oneOf(Object.values(types_1.buttonVariant)),
    hasShadow: prop_types_1.default.bool,
    isActive: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    secondary: prop_types_1.default.bool,
    isCircular: prop_types_1.default.bool,
    size: prop_types_1.default.oneOf(Object.values(types_1.buttonSize)),
    testId: prop_types_1.default.string,
    isDestructive: prop_types_1.default.bool,
};
Button.defaultProps = {
    variant: types_1.buttonVariant.primary,
    hasShadow: undefined,
    isActive: false,
    isDisabled: false,
    secondary: false,
    isCircular: false,
    size: types_1.buttonSize.medium,
    testId: 'BUTTON',
    isDestructive: false,
};
exports.default = (0, oxygen_config_1.withTheme)(Button, themeName_1.THEME_NAME);
